/* eslint-disable no-eval */
import axios from 'axios';
import { dot } from 'dot-object';
import React, { useContext, useEffect } from 'react';
import { Select } from 'antd';
import { getInputProp } from '../../helper';
import { SelectContext } from '../../../../context/Select';
import { propHasValue } from '../../../../components/DynamicFormNew/helper';
import { getToken } from 'datastake-daf/src/helpers/Token';
import { getPopupContainer } from '../../../../helpers/popUp';
import { getMainApiUrl, getAppHeader } from '../../../../services/BaseService';
import i18next from 'i18next';

const EditSelect = ({
  value,
  formsValue,
  filterSelectOptions,
  address,
  addressData,
  props,
  setAddress,
  keyy,
  values: allValues,
  dataLink,
  update,
  valueChangeKey = '',
}) => {
  const {
    valuesLength,
    changeValue,
    options,
    changeOptions,
  } = useContext(SelectContext);
  const values = (allValues || []).filter((v) => v[keyy]);
  const length = valuesLength[valueChangeKey] || 0;
  const opts = options[valueChangeKey] || [];

  useEffect(() => {
    if (length !== values.length) {
      changeValue(valueChangeKey, values.length);
      const endpoint = `${getMainApiUrl()}/query/options`;

      axios.post(endpoint, {
        entity: dataLink.entity,
        method: 'getOptions',
        mapper: {
          label: 'name',
          value: 'parent',
        },
        filters: {
          parent: { $in: values.map(val => val[keyy]) },
        },
      }, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          ...getAppHeader(),
        },
      }).then(({ data }) => {

        if (propHasValue(value)) {
          const selectOption = (data || []).find(o => o.value === value);
          if (!selectOption) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            value = undefined;
            update(undefined);
          }
        }

        changeOptions(valueChangeKey, data || []);
      });
    }
  }, []);

  return <Select size="large" autoComplete="new-password"
    allowClear
    {...getPopupContainer()}
    showSearch
    filterOption={filterSelectOptions}
    optionFilterProp="children"
    value={value}
    {...props}
    placeholder={i18next.t('Select one option')}
    onChange={(val, selectedValue) => {
      if (address && selectedValue) {
        dot.str(address, selectedValue.children, addressData);
        setAddress({
          ...addressData
        })
      }
      if (props.onChange) {
        props.onChange(val);
      }
      update(val);
    }}
  >
    {(opts || []).map((option, i) => {
      const otherProps = {};
      if (option.options) {
        Object.keys(option.options).forEach(prop => {
          if (eval(option.options[prop])) {
            Object.assign(otherProps, {
              [prop]: eval(option.options[prop])(value || [])
            });
          }
        });
      }
      return option.items ?
        <Select.OptGroup label={option.label}>
          {option.items.map((og, j) =>
            <Select.Option value={og.value} key={`${i}${j}`}>
              {og.label}
            </Select.Option>
          )}
        </Select.OptGroup> :
        <Select.Option value={option.value} key={option.value} {...otherProps}>
          {option.label}
        </Select.Option>
    })}
  </Select>
}

export default EditSelect;
